__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@econ/client";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@economic/react-app", "4.1.0", function() { return Promise.all([__webpack_require__.e(9356), __webpack_require__.e(5028), __webpack_require__.e(6983), __webpack_require__.e(9284), __webpack_require__.e(8801), __webpack_require__.e(8915)]).then(function() { return function() { return __webpack_require__(6983); }; }); });
			register("@economic/taco", "2.28.0", function() { return Promise.all([__webpack_require__.e(5587), __webpack_require__.e(8092), __webpack_require__.e(2455), __webpack_require__.e(6475), __webpack_require__.e(1049), __webpack_require__.e(9284), __webpack_require__.e(7862), __webpack_require__.e(7082), __webpack_require__.e(8989), __webpack_require__.e(3898), __webpack_require__.e(2113), __webpack_require__.e(8412)]).then(function() { return function() { return __webpack_require__(6475); }; }); });
			register("@lingui/core", "4.5.0", function() { return __webpack_require__.e(9555).then(function() { return function() { return __webpack_require__(89555); }; }); });
			register("@lingui/react", "4.5.0", function() { return Promise.all([__webpack_require__.e(8989), __webpack_require__.e(2080)]).then(function() { return function() { return __webpack_require__(82080); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(3935), __webpack_require__.e(3264), __webpack_require__.e(7418)]).then(function() { return function() { return __webpack_require__(73935); }; }); });
			register("react-router-dom", "6.16.0", function() { return Promise.all([__webpack_require__.e(9818), __webpack_require__.e(6116)]).then(function() { return function() { return __webpack_require__(49818); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(7294).then(function() { return function() { return __webpack_require__(67294); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};